<template>
	<card>
		<template slot="header">
			<h4 class="mb-0">รายการสมัครสมาชิก</h4>
		</template>
		<template>
			<pie-chart :height="250" :chart-data="chartData" :extra-options="extraOptions" />
		</template>
	</card>
</template>

<script>
import PieChart from '../../components/Charts/PieChart'

import { Charts } from '../../components/Charts/config'

export default {
	props: ['data'],
	components: {
		PieChart,
	},
	data() {
		return {
			chartData: {},
			extraOptions: {
				responsive: true,
			},
		}
	},
	methods: {
		updateChart(v) {
			this.chartData = {
				labels: Object.keys(v.knowFrom).map((x) => x.toUpperCase()),
				datasets: [
					{
						data: Object.values(v.knowFrom),
						backgroundColor: [
							Charts.colors.theme['info'],
							Charts.colors.theme['primary'],
							Charts.colors.theme['success'],
							Charts.colors.theme['warning'],
							Charts.colors.theme['danger'],
							Charts.colors.theme['default'],
							'#f44336',
							'#ff6f00',
						],
					},
				],
			}
		},
	},
	created() {
		this.updateChart(this.data)
	},
	watch: {
		data(v) {
			this.updateChart(v)
		},
	},
}
</script>
